import * as React from 'react';
import Api from 'requestapijs';
import { Omit } from 'sha-el-design/lib/helpers';
import { EmployeeNodeConnection, EmployeeNodeEdge, ID } from '../../../schema';
import { employeeDropdownQuery } from './constants';
import { AutoCompleteAsyncProps, AutoCompleteAsync } from 'sha-el-design/lib/components/AutoComplete/AutoCompleteAsync';
import { API_URL, HEADER } from '../../config';

export class EmployeeDropdown extends React.Component<Props, {}> {
  static defaultProps = {
    extrafields: [],
  };

  constructor(props) {
    super(props);
  }

  fetch = (name: string) =>
    new Promise<EmployeeNodeEdge[]>((resolve, reject) => {
      Api.graphql<{ name: string }, { data: { allEmployees: EmployeeNodeConnection } }>(
        API_URL,
        { name },
        employeeDropdownQuery,
        HEADER,
        (v) => resolve(v.data.allEmployees.edges),
        (e) => reject(e),
      );
    })

  render() {
    return (
      <AutoCompleteAsync
        {...this.props}
        mode='single'
        data={(v) => this.fetch(v)}
        inputProps={{
          ...this.props.inputProps,
        }}
        filterFunction={() => true}
      />
    );
  }
}

interface Props extends Omit<AutoCompleteAsyncProps<EmployeeNodeEdge>, 'data'> {
  mode: 'single';
  value: EmployeeNodeEdge;
  onChange: (v: EmployeeNodeEdge) => void;
}
